<template>
  <div class="w-100">
    <PwaBlob v-if="isOnline && !isPwaInstalled && $vuetify.breakpoint.mdAndUp && !$_kioskMode" />
    <router-view></router-view>
    <v-container>
      <v-row v-if="isOnline && !isPwaInstalled && $vuetify.breakpoint.smAndDown && !$_kioskMode">
        <v-col cols="12">
          <PwaBlobSmallScreen />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <CategoriesButtons :categories="categories" />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-for="species in featuredSpecies"
          :key="species.id"
          :cols="$_colsWidth"
          class="d-flex child-flex"
        >
          <SpeciesCard class="" :species="species" />
        </v-col>
      </v-row>
    </v-container>

    <BandAlien />
    <BandRed />
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */

import BandAlien from '@/components/BandAlien.vue'
import BandRed from '@/components/BandRed.vue'
import CategoriesButtons from '@/components/CategoriesButtons.vue'
import SpeciesCard from '@/components/SpeciesCard.vue'
import Setup from '@/mixins/Setup.js'
import Misc from '@/mixins/Misc.js'
import PwaBlob from '@/components/PwaBlob'
import PwaBlobSmallScreen from '@/components/PwaBlobSmallScreen'

export default {
  name: 'Home',
  components: {
    BandAlien,
    BandRed,
    CategoriesButtons,
    SpeciesCard,
    PwaBlob,
    PwaBlobSmallScreen
  },
  mixins: [Setup, Misc],
  data() {
    return {
      search: ''
    }
  },
  created() {},
  mounted() {
    this.$store.dispatch('setGeneralArea', 'all')
  },
  computed: {
    featuredSpecies() {
      return this.$store.getters.getFeaturedSpecies
    },
    categories() {
      return this.$store.state.categories
    },
    isPwaInstalled() {
      return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true
    }
  },
  methods: {
    setup() {},
    sendSearch(e) {
      if (e.type === 'keydown') {
        if (e.key === 'Enter') {
          this.$router.push({ name: 'Search', query: { q: this.search } })
        }
      } else {
        this.$router.push({ name: 'Search', query: { q: this.search } })
      }
    }
  }
}
</script>

<style scoped></style>
